const configs = {
    urlApiFiles : "https://api.mokapp.app.br" //prod
    //urlApiFiles : "http://localhost:3003" //dev
};

export default configs;